var _rect, _path, _g, _path2, _g2, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEuDrops = function SvgEuDrops(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 40,
    width: 53,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 45,
    width: 49,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0657 45.2845H60.3867V53.0001H12.0657V45.2845Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0657 49.1429C16.0575 46.875 25.3773 45.2845 36.2262 45.2845C47.0757 45.2845 56.3949 46.875 60.3867 49.1429C56.3949 51.4123 47.0757 53.0002 36.2262 53.0002C25.3773 53.0002 16.0575 51.4123 12.0657 49.1429Z",
    fill: "#C8C8C8"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7437,
    y: 32.4065,
    width: 31.2472,
    height: 5.76871,
    rx: 2.88435,
    transform: "rotate(11.7081 21.7437 32.4065)",
    fill: "#DF6D65"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.748,
    y: 12,
    width: 0.961451,
    height: 13.4603,
    rx: 0.480726,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4397,
    y: 14.8844,
    width: 0.961451,
    height: 16.8254,
    rx: 0.480726,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1321,
    y: 14.4036,
    width: 0.961451,
    height: 16.3447,
    rx: 0.480726,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.6402,
    y1: 51.4831,
    x2: 38.5844,
    y2: 32.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEuDrops);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/eu-drops.7839ce4026b5aa005b3d70f0dceaa9d5.blank.svg";